import React from "react";
import Box from "@material-ui/core/Box";
import {formatQuantity} from "assets/utils";
import {Paper, Typography} from "@material-ui/core";
import {ResponsiveBar} from "@nivo/bar";
import {curveCatmullRom, line} from "d3-shape";

const moment = require('moment');

const formatId = (id, fullYear = false) => {
    let [month, anioActual = ''] = id.split('_');

    let ret = `${moment(month, "M").format('MMM')}`;

    if (!fullYear)
        anioActual = anioActual.slice(-2);

    return `${ret} ${anioActual}`;
}

export const CompradoresMensualesChart = React.memo(function ({height, data}) {
    const colors = {compradores: "rgba(0, 150, 136, 0.8)", baseDeDatos: "rgba(36, 173, 160, 0.5)", aVisitar: "rgba(255,179,26,0.8)"};
    const labels = {compradores: "Compradores", baseDeDatos: "Base de Datos", aVisitar: "A visitar"};
    const keys = ['compradores', 'baseDeDatos', 'aVisitar'];

    const Points = ({bars}) => {
        return (
            <>
                {bars.map((bar, index) => (
                    // Render the circle SVG in chart using Bars co-ordinates.
                    <circle
                        key={index}
                        // Scale x-cordinate of the circle to the center of bar
                        cx={bar.x + bar.width / 2}
                        // Scale y-cordinate of the circle to top of the bar
                        cy={bar.y}
                        r={3}
                        fill="black"
                        stroke="black"
                        style={{pointerEvents: "none"}}
                    />
                ))}
            </>
        );
    };

    const Lines = ({bars, color}) => {
        const lineGenerator = line()
            .x((bar) => bar.x + bar.width / 2)
            .y((bar) => bar.y)
            .curve(curveCatmullRom.alpha(0.5));

        return (
            <path
                d={lineGenerator(bars)}
                fill="none"
                stroke={color}
                style={{pointerEvents: "none", strokeWidth: "2"}}
            />
        );
    };

    const ChartLines = ({bars, xScale, yScale}) => {
        return <>
            <Points bars={bars}/>
            {keys.map((key, index) => <Lines key={index} bars={bars.filter(bar => bar.data.id === key)} color={"rgba(200, 30, 15, 1)"}/>)}
        </>
    };

    return (
        <Box style={{height: `${height}px`, width: '100%'}} className={'d-flex justify-content-center align-items-center'}>
            {(data.length <= 0) ?
                <Typography align={"center"} color={"textSecondary"}>
                    No hay datos para mostrar
                </Typography> :
                <ResponsiveBar
                    data={data}
                    keys={keys}
                    indexBy={'id'}
                    margin={{top: 10, right: 40, bottom: 60, left: 80}}
                    padding={0.3}
                    groupMode="grouped"
                    valueScale={{type: 'linear'}}
                    indexScale={{type: 'band', round: true}}
                    // valueFormat={{format: '', enabled: false}}
                    colors={keys.map(key => colors[key])}
                    borderColor={{from: 'color', modifiers: [['darker', 1.6]]}}
                    axisBottom={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: 'Meses',
                        legendPosition: 'middle',
                        legendOffset: 40,
                        format: (id) => formatId(id)
                    }}
                    axisLeft={{
                        tickSize: 0,
                        tickPadding: 15,
                        tickRotation: 0,
                        legend: 'Cantidad',
                        legendPosition: 'middle',
                        legendOffset: -50,
                        format: '~s'
                    }}
                    enableGridY={false}
                    labelSkipWidth={20}
                    // labelTextColor={{from: 'color', modifiers: [['darker', 2.9]]}}
                    labelTextColor={"#333333"}
                    labelFormat={value => formatQuantity(value)}
                    label={d => `${formatQuantity(d.value)}`}
                    isInteractive={true}
                    tooltip={(props) => {
                        return (
                            <Paper elevation={1} className={'p-2'}>
                                <Typography variant={"body2"} style={{color: colors[props.id]}} component={"span"}>
                                    <b>{labels[props.id]}: </b>
                                </Typography>
                                <Typography variant={"body2"} component={"span"}>
                                    <b>{formatQuantity(props.value)}</b>
                                </Typography>
                                <Typography variant={"body2"} className={'mt-2'} align={"left"}>
                                    {formatId(props.indexValue, true)}
                                </Typography>
                            </Paper>
                        )
                    }}
                    pointSize={10}
                    pointColor={{theme: 'background'}}
                    pointBorderWidth={2}
                    pointBorderColor={{from: 'serieColor'}}
                    pointLabelYOffset={-13}
                    useMesh={true}
                    animate={true}
                    motionStiffness={90}
                    motionDamping={15}
                    layers={["grid", "axes", "bars", ChartLines]}
                />
            }
        </Box>
    )
})
